import { ManagerProspectColumnId } from '@/experiences/sales-portal/domain/prospects/screens/prospects/types';
import type { SortingState } from '@tanstack/react-table';

export const DEFAULT_SORTING: SortingState = [
  { desc: false, id: ManagerProspectColumnId.Name },
];
